import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
	selector: 'amd-in-page-message',
	templateUrl: './in-page-message.component.html',
	styleUrls: ['./in-page-message.component.scss']
})
export class InPageMessageComponent {

	@Input() messages?: InPageMessage[];
	@Input() stickyPosition: boolean = false;
	@Output() onLinkClick: EventEmitter<void> = new EventEmitter<void>();
	inPageMessageSize: typeof InPageMessageSize = InPageMessageSize;

	icons: { [key: string]: string } = {
		[InPageMessageType.INFO]: 'amd-icon--circle-info-16x16',
		[InPageMessageType.WARNING]: 'amd-icon--circle-alert-16x16',
		[InPageMessageType.SUCCESS]: 'amd-icon--circle-check-16x16',
		[InPageMessageType.ERROR]: 'amd-icon--circle-error-16x16'
	};

	constructor() {
	}
}

export enum InPageMessageSize {
	SMALL = 'small',
	MEDIUM = 'medium',
	LARGE = 'large',
}

export enum InPageMessageType {
	WARNING = 'warning',
	SUCCESS = 'success',
	ERROR = 'error',
	INFO = 'info'
}


export interface InPageMessage {
	type: InPageMessageType;
	text: string;
	size?: InPageMessageSize;
	link?: string;
}
